<template>
    <div>
        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="location_out_id" class="form-label">Polazna lokacija</label>
                <input type="hidden" name="location_out_id" :value="(selected_location_out == undefined) ? '' :
                selected_location_out.value">
                <v-select id="location_out_id"
                    :filterable="false"
                    v-model="selected_location_out"
                    :disabled="disableEdit()"
                    :options="location_out"
                    @search="locationOutSearch"
                >
                    <template slot="no-options">
                        Pretraživanje lokacija
                    </template>
                </v-select>
            </div>

            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="location_in_id" class="form-label">Odredišna lokacija</label>
                <input type="hidden" name="location_in_id" :value="(selected_location_in == undefined) ? '' :
                selected_location_in.value">
                <v-select id="location_in_id"
                    :filterable="false"
                    v-model="selected_location_in"
                    :disabled="disableEdit()"
                    :options="location_in"
                    @search="locationInSearch"
                >
                    <template slot="no-options">
                        Pretraživanje lokacija
                    </template>
                </v-select>
            </div>

        </div>

        <div class="flex -mx-1 mb-4 mt-8"  v-for="(product, index) in products" :key="'product-' + index">
            <div class="form-group w-1/2 pl-1 pr-16">
                <label for="selected_product" class="form-label">Odaberi uređaj</label>
                <v-select id="selected_product"
                          :filterable="false"
                          v-model="products[index]"
                          :disabled="disableEdit()"
                          :options="allProducts"
                          @search="productsSearch">
                    <template slot="no-options">
                        Pretraživanje tipova opreme
                    </template>
                </v-select>
            </div>
            <div class="form-group w-1/6 pl-1 pr-4">
                <label :for="'quantity-'+ index" class="form-label">Unesi količinu</label>
                <input type="number"
                       class="form-control"
                       :id="'quantity-'+ index"
                       :disabled="disableEdit()"
                       v-model="products[index].quantity">
            </div>

            <div class="form-group w-1/6 pl-1 pr-16">
                <label :for="'quantity-'+ index" class="form-label">Dodano</label>
                <span>{{ product.qr_codes.length }} / {{ products[index].quantity }}</span>
            </div>

            <div class="form-group flex items-center justify-center w-1/6 pl-1 pr-2" v-if="product.track_quantitatively || product.temporary_quantitative">
                <span>Oprema se prati količinski</span>
            </div>

            <div v-if="!product.track_quantitatively && !product.temporary_quantitative">
                <span v-if="product.qr_codes.length > 0">Unosi:</span><br>
                <span v-for="(qrCode, qrIndex) in product.qr_codes" :key="'qrCode-' + qrIndex">
                    <div class="flex flex-col">
                        <div>
                            <strong>QR:</strong> {{qrCode.code}}
                        </div>
                        <div v-if="qrCode.serial_no != ''">
                            <strong>S/N:</strong> {{qrCode.serial_no}}
                        </div>
                    </div>
                    <button
                        v-if="!hideShipped"
                        class="btn btn-xs btn-danger"
                        :disabled="disableEdit()"
                        @click.prevent="removeQr(index, qrIndex)"
                    >
                        <span>Ukloni QR</span>
                    </button><br>
                </span>
            </div>
            <div v-if="item.status == 'draft' || _.isEmpty(item)">
                <div v-if="!lessThanTwo && !hideShipped" class="ml-auto">
                    <label :for="'remove-product-' + index" class="">&nbsp;</label>
                    <button
                        :id="'remove-product-' + index"
                        type="button"
                        class="btn btn-delete border-0 my-0 py-0 px-2 hover:text-primary flex"
                        :disabled="disableEdit()"
                        @click="removeProduct(index)"
                    >Ukloni uređaj</button>
                </div>
            </div>
        </div>

        <div v-if="!hideShipped" class="form-group w-full px-1 bg-gray-100">
            <div class="flex w-full items-end my-8">
                <div class="flex flex-col items-start w-3/5 pl-8">
                    <label for="equipmentQr" class="form-label pr-6 mb-1 text-sm text-text">Unos QR koda ili serijskog broja</label>
                    <v-select id="equipmentQr"
                            :filterable="false"
                            v-model="selectedEquipmentQr"
                            :options="equipmentQr"
                            :disabled="disableQrSelection()"
                            @search="qrCodeSearch">
                        <template slot="no-options">
                            Unesite QR code sa opreme
                        </template>
                    </v-select>
                </div>
                <div class="flex w-1/5 justify-center items-center ml-2 mb-1">
                    <button class="btn btn-lg btn-success btn-add-equipment" :disabled="!equipmentSelected()"
                            @click.prevent="addEquipment()">
                        <span>Dodaj opremu</span>
                    </button>
                </div>
            </div>
        </div>

        <span v-for="(product, index) in products" :key="'h_product-' + index">
            <input
                type="hidden"
                :name="'products[' + index + '][id]'"
                :value="product.value"
            >
            <input
                type="hidden"
                :name="'products[' + index + '][quantity]'"
                :value="product.quantity"
            >
            <span
                v-for="(qrCode, qrIndex) in product.qr_codes"
                :key="'h_qrCode-' + qrIndex"
            >
                <input
                    type="hidden"
                    :name="'products[' + index + '][qr_codes][' + qrIndex + '][id]'"
                    :value="qrCode.value"
                >
            </span>
        </span>

        <div v-if="!hideShipped" class="flex -mx-1 mb-4 mt-8 justify-between">
            <button class="btn btn-lg btn-success btn-yellow" :disabled="disableEdit()"
                    @click.prevent="addNewProduct()">
                <span>Dodaj novi uređaj</span>
            </button>
        </div>

        <hr>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-1/2 px-1">
                <label for="remark" class="form-label">Napomena</label>
                <textarea
                    class="form-control min-h-remark"
                    name="remark"
                    :disabled="item.status == 'shipped' || item.status == 'received'"
                    :value="remark"
                ></textarea>
            </div>
        </div>

        <hr>
        <div class="flex justify-end">
            <div class="mx-2" v-if="item.status == 'draft' && item.type != 'povrat' && item.type != 'revers'">
                <button
                    name="change_status"
                    value="ship_request"
                    class="btn btn-lg btn-success flex ml-auto"
                    :disabled="checkProductCounts()"
                >
                    <span>Pošalji zahtjev za isporuku</span>
                </button>
                <div class="flex">
                    <span class="ml-auto" v-if="checkProductCounts()">
                        Potrebno je unijeti QR kodove ili serijske brojeve svih uređaja na međuskladišnici.
                    </span>
                </div>
            </div>
            <div v-if="item.type != 'povrat' && item.type != 'revers' && item.status != 'ship_request' && item.status != 'shipped'">
                <button
                    class="btn btn-lg btn-success flex ml-auto"
                    :disabled="disableSubmit()"
                >
                    <img src="/svg/confirm.svg" alt="confirm" class="mr-2">
                    <span v-text="pageTitle"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

export default {
    props: {
        productsAndQr: {
            type: Array,
            default: () => ([])
        },
        pageTitle: {
            type: String,
            default: null
        },
        selectedLocationOut: {
            type: Object,
            default: () => ({})
        },
        selectedLocationIn: {
            type: Object,
            default: () => ({})
        },
        item: {
            type: Object,
            default: () => ({})
        },
        remark: {
            type: String,
            default: ''
        },
        user: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            hideShipped: false,
            location_out: [],
            location_in: [],
            equipmentQr: [],
            allProducts: [],
            products: [],
            selectedEquipmentQr: null,
            selected_location_in: null,
            selected_location_out: null,
            selected_products: [],
            quantityDifference: [],
            itemData: null,
            authorisedUserRole: [],
            excludeCodes: [],
        }
    },

    created() {
        this.authorisedUserRole = this.user.role_key;
        this.selected_location_in = this.selectedLocationIn;
        this.selected_location_out = this.selectedLocationOut;
        this.itemData = this.item;
        this.products = this.productsAndQr;


        this.products.forEach((item) => {
            if (item.qr_codes.length > 0) {
                item.qr_codes.forEach((eq) => {
                    if (eq.code && eq.code != '') {
                        this.excludeCodes.push(eq.code)
                    } else {
                        this.excludeCodes.push(eq.serial_no)
                    }
                })
            }
        })

        this.initProducts()
    },

    mounted() {
        if (this.item.status == 'ship_request' || this.item.status == 'shipped') {
            this.hideShipped = true
        }

        this.locationOutSearch('', '')
        this.locationInSearch('', '')
        this.productsSearch('', '')
    },

    computed: {
        lessThanTwo() {
            return this.products.length < 2
        },
    },

    methods: {
        removeProduct(index) {
            this.products.splice(index, 1)
        },

        initProducts() {
            if (this.products.length === 0) {
                this.addNewProduct()
            }
        },

        addNewProduct() {
            this.products.push({
                label: '',
                value: null,
                quantity: 0,
                qr_codes: [],
            });
        },

        locationOutSearch(search, loading) {
            this.isOutSearchLoading = true;
            fetch('/api/search/locations-out/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.location_out = json.data;
                    this.isOutSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        locationInSearch(search, loading) {
            this.isInSearchLoading = true;
            fetch('/api/search/locations-in/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.location_in = json.data;
                    this.isInSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        productsSearch(search, loading) {
            this.isInSearchLoading = true;
            fetch('/api/all-products/' + escape(search))
                .then(res => res.json())
                .then(json => {
                    this.allProducts = json.data;
                    this.isInSearchLoading = false;
                })
                .catch(err => console.warn(err));
        },

        qrCodeSearch(search, loading) {
            this.isInSearchLoading = true;
            axios.get(route('admin.api.search.stock-move.equipment', {
                        location: this.selected_location_out.value,
                        code: search,
                        exclude: this.excludeCodes,
                    }))
                    .then((response) => {
                        this.equipmentQr = response.data.data;
                        this.isInSearchLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
        },

        equipmentSelected() {
            return this.selectedEquipmentQr
        },

        locationsSelected() {
            return this.selected_location_in && this.selected_location_out
        },

        disableSubmit() {
            return !(
                    Object.keys(this.selected_location_in).length !== 0 &&
                    Object.keys(this.selected_location_out).length !== 0
                )
        },

        disableQrSelection() {
            if (this.disableEdit()) {
                return true
            } else if (!this.selected_location_out.value) {
                return true
            }

            return false
        },

        disableEdit() {
            return !(
                this.itemData.status == 'draft' ||
                this.itemData.status === undefined
            )
        },

        removeQr(index, qrIndex) {
            let qrItem = this.products[index]['qr_codes'][qrIndex]

            this.products[index]['qr_codes'].splice(qrIndex, 1);

            let excludeIndex = this.excludeCodes.indexOf(qrItem.code)

            if (excludeIndex > -1) {
                this.excludeCodes.splice(excludeIndex, 1)
            }
        },

        addEquipment() {
            let arrayLength = this.products.length;

            for (let i = 0; i < arrayLength; i++) {
                if (this.products[i]['value'] == this.selectedEquipmentQr.product_id) {
                    if (this.products[i]['qr_codes'].length == this.products[i]['quantity']) {
                        alert('Već su dodani svi QR kodovi za ' + this.products[i]['label']);
                    } else if (this.products[i]['qr_codes'].length > this.products[i]['quantity']) {
                        alert('Već je dodano previše QR kodova za ' + this.products[i]['label']);
                    } else {
                        this.equipmentQr = []

                        // Adding all the selected QR-s to a exclude array and send it with the request
                        if (this.selectedEquipmentQr.code && this.selectedEquipmentQr.code != '') {
                            this.excludeCodes.push(this.selectedEquipmentQr.code)
                        } else {
                            this.excludeCodes.push(this.selectedEquipmentQr.serial_no)
                        }

                        this.products[i]['qr_codes'].push({
                            label: this.selectedEquipmentQr.label,
                            value: this.selectedEquipmentQr.value,
                            code: this.selectedEquipmentQr.code,
                        });
                    }
                }
            }

            this.selectedEquipmentQr = null
        },

        checkProductCounts() {
            let invalidCount = false

            this.products.forEach((product) => {
                if (
                    !product.track_quantitatively &&
                    !product.temporary_quantitative &&
                    product.qr_codes.length != product.quantity
                ) {
                    invalidCount = true
                }
            });

            return invalidCount
        },

        productDiff(productId) {
            let countProducts = 0;

            let arrayLength = this.equipment.length;
            for (let i = 0; i < arrayLength; i++) {
                if (this.equipment[i]['product_id'] == productId) {
                    countProducts += 1;
                }
            }

            let productQuantity = (this.products_quantity[productId]) ?
                parseInt(this.products_quantity[productId]) : 0;

            let diff = productQuantity - countProducts;

            if (!diff) {
                return 'Ok'
            } else if (diff < 0) {
                return (diff*-1) + ' više dodano'
            } else {
                return diff + ' treba dodati'
            }
        }
    },
}
</script>
